import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { registrationApi } from './registration.api';
import type { RegistrationsListParams } from '../types';
import { STALE_TIME } from '@/lib/query/stale-times';

export const registrationKeys = {
  all: ['registrations'] as const,
  lists: () => [...registrationKeys.all, 'list'] as const,
  list: (filters: RegistrationsListParams) =>
    [...registrationKeys.lists(), filters] as const,
  details: () => [...registrationKeys.all, 'detail'] as const,
  detail: (id: number) => [...registrationKeys.details(), id] as const,
  metrics: () => [...registrationKeys.all, 'metrics'] as const,
  activities: (id: number) =>
    [...registrationKeys.details(), id, 'activities'] as const
};

export const registrationQueries = {
  list: (filters: RegistrationsListParams = {}) =>
    queryOptions({
      queryKey: registrationKeys.list(filters),
      queryFn: () => registrationApi.getAll(filters),
      placeholderData: keepPreviousData,
      // This one query backs four listings (registration, review, sticking,
      // supervisor) and every one of them renders the cross-stage pipeline pill.
      // A container's stage is advanced by whichever downstream feature owns it
      // — or by an OCR worker — and none of those invalidate
      // `registrationKeys`, so only mount refetch keeps the pill truthful.
      staleTime: STALE_TIME.live
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: registrationKeys.detail(id),
      queryFn: () => registrationApi.getById(id),
      enabled: id > 0
    }),

  metrics: () =>
    queryOptions({
      queryKey: registrationKeys.metrics(),
      queryFn: () => registrationApi.metrics(),
      staleTime: STALE_TIME.metrics
    }),

  activities: (id: number) =>
    queryOptions({
      queryKey: registrationKeys.activities(id),
      queryFn: () => registrationApi.getActivities(id),
      enabled: id > 0
    })
};
